module.exports = __webpack_public_path__ + "fonts/montserrat-latin-700-normal.85b386a.woff";